import { CircularProgressProps } from '@mui/material';
import React from 'react';

import { VisuallyHidden } from '@/shared/components/ui/shared-styles/shared-styles.styled';
import {
  StyledCircularProgress,
  Wrapper,
} from '@/shared/components/ui/spinner/spinner.styled';

const sizeMap = {
  xs: 12,
  sm: 16,
  md: 32,
  lg: 48,
  xl: 64,
};

type SpinnerProps = CircularProgressProps & {
  size?: keyof typeof sizeMap;
};

export const Spinner: React.FC<SpinnerProps> = ({ size = 'md', ...rest }) => {
  return (
    <Wrapper>
      <StyledCircularProgress $size={sizeMap[size]} {...rest} />
      <VisuallyHidden>Loading</VisuallyHidden>
    </Wrapper>
  );
};
